export const topics = [
  {
    id: "t1",
    title: "剧组盒饭被曝区别对待，群演晒出餐盒照片引爆讨论",
    category: "娱乐八卦",
    categorySlug: "entertainment",
    summary:
      "有群演在社交平台晒出片场餐盒对比照，称主演与群演的伙食标准差距明显。照片发出后评论区迅速分成两派，有人心疼一线演员的工作强度，也有人认为后勤标准不该按咖位划分。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20poster%20style%20with%20warm%20cream%20paper%20background%20and%20soft%20studio%20lighting%2C%20stylized%20abstract%20composition%20representing%20film%20set%20catering%20boxes%20and%20coffee%20cups%20on%20a%20backstage%20table%2C%20muted%20crimson%20and%20amber%20accents%2C%20gentle%20grain%20texture%2C%20high%20detail%2C%20centered%20subject%2C%20no%20text&width=800&height=600&seq=bl-t1-cover&orientation=landscape",
    heat: 98620,
    commentCount: 3421,
    followers: 18240,
    author: "看点编辑组",
    date: "2026-09-08",
    tags: ["片场爆料", "评论区高能", "剧组后勤"],
    readTime: "6 分钟阅读",
    content: [
      "一张片场餐盒的对比照片，让原本没有多少人关注的剧组后勤话题冲上了热搜。发布者自称是参与该剧拍摄的群演，照片中两盒餐食摆在同一条长椅上，一盒是标准搭配，另一盒则多出几样热菜与水果。",
      "发帖者表示，自己在片场连续候场十多个小时，中途只领到一份冷掉的正餐。帖子发出后不到三小时，转发量就突破了六万，评论区从心疼群演迅速蔓延到讨论剧组预算该怎么分配。",
      "随后有自称剧组工作人员的账号出面回应，解释两类餐食由不同供应商承接，主演餐由演员统筹单独安排，并非刻意区分待遇。不过这份说明并没有让讨论平息，反而让更多现场照片被翻了出来。",
      "值得注意的是，这次争议里真正被大量引用和转发的，是评论区几条逻辑清楚的长回复，以及一个关于后勤标准该由谁定的站队投票。截至发稿，投票已有超过三万人参与。",
    ],
    pros: [
      "演员长时间高强度拍摄，伙食标准有差异属于行业常见安排，不必过度解读。",
      "剧组预算有限，把更多资源放在主演身上，是为了保证整部作品的拍摄进度。",
      "后勤供应商不同，餐标自然不同，这与尊不尊重并没有直接关系。",
    ],
    cons: [
      "群演同样是剧组运转的一环，同工同场却餐标悬殊，会直接影响现场士气。",
      "真正引发反感的不是差价，而是回应里透出的那种理所应当的态度。",
      "既然拍摄现场统一管理，后勤标准就应该有公开、可解释的规则。",
    ],
    attitude: { support: 46, neutral: 22, oppose: 32 },
    comments: [
      {
        id: "t1c1",
        nickname: "前排小板凳",
        avatarClass: "bg-primary-100 text-primary-800",
        badge: "神评",
        content:
          "别人晒的是餐盒，我看到的是一整套咖位定价表。这个行业里最缺的从来不是预算，是一句今天大家都不容易。",
        likes: 4820,
        replies: 316,
        time: "3 小时前",
      },
      {
        id: "t1c2",
        nickname: "吃瓜不吐皮",
        avatarClass: "bg-secondary-100 text-secondary-900",
        badge: "高能",
        content:
          "别急着骂，先把几张照片的时间地点对上。同一部长椅上放两盒饭，不代表是同一天、同一个供应商，评论区已经有人把拍摄日程扒出来了。",
        likes: 3610,
        replies: 428,
        time: "5 小时前",
      },
      {
        id: "t1c3",
        nickname: "夜班搬运工",
        avatarClass: "bg-accent-100 text-accent-900",
        badge: "热评",
        content:
          "我在剧组做过三个月场务。说实话，大部分时候不是谁故意要区别对待，而是流程里根本没人负责把这件事说清楚。",
        likes: 2970,
        replies: 152,
        time: "6 小时前",
      },
      {
        id: "t1c4",
        nickname: "理性围观中",
        avatarClass: "bg-background-200 text-foreground-800",
        badge: "",
        content: "投票我选了中立。比起谁吃得更好，我更想知道群演的候场时长和结算方式到底有没有保障。",
        likes: 1840,
        replies: 97,
        time: "7 小时前",
      },
    ],
    poll: {
      question: "剧组后勤餐标按咖位区分，你怎么看？",
      options: [
        { label: "可以理解，属于行业惯例", votes: 13820 },
        { label: "说不好，要看具体规则", votes: 6610 },
        { label: "不该区分，应统一标准", votes: 9605 },
      ],
      totalVotes: 30035,
      closesAt: "9 月 12 日 22:00",
    },
  },
  {
    id: "t2",
    title: "综艺剪辑被指刻意制造冲突，观众喊话放出完整版",
    category: "影视综艺",
    categorySlug: "screen",
    summary:
      "最新一期综艺播出后，有观众整理时间线指出剪辑顺序与现场流程不符，认为节目组刻意放大嘉宾之间的摩擦。话题下的评论区高能回复密集，投票结果也呈现明显分化。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20poster%20style%20with%20warm%20cream%20paper%20background%20and%20soft%20studio%20lighting%2C%20stylized%20abstract%20composition%20representing%20a%20television%20editing%20timeline%20made%20of%20film%20strips%20inside%20a%20screening%20room%2C%20muted%20crimson%20and%20amber%20accents%2C%20gentle%20grain%20texture%2C%20high%20detail%2C%20centered%20subject%2C%20no%20text&width=800&height=600&seq=bl-t2-cover&orientation=landscape",
    heat: 87340,
    commentCount: 2876,
    followers: 14310,
    author: "看点编辑组",
    date: "2026-09-07",
    tags: ["综艺剪辑", "网友神评论", "时间线整理"],
    readTime: "5 分钟阅读",
    content: [
      "节目正片播出不到一晚，社交平台上就出现了长达十几页的时间线整理帖。发帖观众逐帧比对了预告、正片与嘉宾当天的直播内容，指出至少三处对话被拆开重新拼接。",
      "争议的核心并不在于能不能剪，而在于剪辑后的呈现方式是否误导了观众对嘉宾关系的判断。多条高赞评论一致提到，节目里那句被反复播放的火药味台词，在现场其实是玩笑语境。",
      "节目组暂未正面回应剪辑问题，只在官方账号发布了一条感谢大家认真观看的动态。这条动态下方的评论区，成了本轮讨论中最集中的观点交锋现场。",
      "有意思的是，这次的投票结果并没有一边倒。支持综艺需要节奏的观众与要求放出完整版的观众票数咬得很紧，中立票也占了将近四分之一。",
    ],
    pros: [
      "综艺是二次创作，节奏和叙事需要剪辑，观众不必把每一秒都当成纪录片来看。",
      "节目时长有限，取舍是必然的，只要不改变对话的基本含义就无可厚非。",
      "争议本身带来了讨论度，说明节目内容确实抓住了观众的注意力。",
    ],
    cons: [
      "把不同时间的对话拼在一起制造冲突，已经越过了创作本身的边界。",
      "观众要的不多，只是希望节目组放出完整版，让事实自己说话。",
      "一旦被发现剪辑引导情绪，之后再精彩的节目也会先被怀疑三分。",
    ],
    attitude: { support: 34, neutral: 27, oppose: 39 },
    comments: [
      {
        id: "t2c1",
        nickname: "时间线侦探",
        avatarClass: "bg-secondary-100 text-secondary-900",
        badge: "高能",
        content:
          "剪辑不是原罪，把前后两句话拼成一句才是。我做了十二年后期，这种接法在业内有个专门的说法，叫造情绪。",
        likes: 5240,
        replies: 289,
        time: "2 小时前",
      },
      {
        id: "t2c2",
        nickname: "追综不熬夜",
        avatarClass: "bg-primary-100 text-primary-800",
        badge: "神评",
        content:
          "节目组说感谢大家认真观看。观众说那你能不能也认真放一次完整版。这段隔空对话我愿称之为年度最好笑的对峙。",
        likes: 4410,
        replies: 233,
        time: "4 小时前",
      },
      {
        id: "t2c3",
        nickname: "半个从业者",
        avatarClass: "bg-accent-100 text-accent-900",
        badge: "热评",
        content: "观众要完整版其实是个合理诉求。多剪一个花絮版，成本并不高，反而能把争议变成口碑。",
        likes: 2380,
        replies: 118,
        time: "6 小时前",
      },
      {
        id: "t2c4",
        nickname: "路人甲第N号",
        avatarClass: "bg-background-200 text-foreground-800",
        badge: "",
        content: "说实话，我看综艺就图个乐。但被这么一扒，再看那期节目确实处处都是设计感。",
        likes: 1560,
        replies: 64,
        time: "8 小时前",
      },
    ],
    poll: {
      question: "综艺剪辑为节奏放大冲突，你能接受吗？",
      options: [
        { label: "能接受，节目需要叙事", votes: 10590 },
        { label: "看情况，别改变原意", votes: 8420 },
        { label: "不能接受，应放完整版", votes: 12180 },
      ],
      totalVotes: 31190,
      closesAt: "9 月 13 日 20:00",
    },
  },
  {
    id: "t3",
    title: "小说改编选角公布，书粉与剧粉在评论区正面交锋",
    category: "影视综艺",
    categorySlug: "screen",
    summary:
      "改编剧官宣主演阵容后，原著读者与剧集观众对选角的看法出现明显分歧。围绕像不像与演不演得出来的讨论，成了本周最热的一组投票。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20poster%20style%20with%20warm%20cream%20paper%20background%20and%20soft%20studio%20lighting%2C%20stylized%20abstract%20composition%20representing%20an%20open%20novel%20turning%20into%20theater%20masks%20under%20a%20single%20spotlight%2C%20muted%20crimson%20and%20amber%20accents%2C%20gentle%20grain%20texture%2C%20high%20detail%2C%20centered%20subject%2C%20no%20text&width=800&height=600&seq=bl-t3-cover&orientation=landscape",
    heat: 79210,
    commentCount: 2415,
    followers: 12980,
    author: "看点编辑组",
    date: "2026-09-06",
    tags: ["选角争议", "原著改编", "观点交锋"],
    readTime: "5 分钟阅读",
    content: [
      "改编剧的选角名单公布当天，相关话题的讨论量在两小时内翻了三倍。原著读者普遍关注的是外形与气质的贴合度，而剧集观众更在意演员过往作品里的表演完成度。",
      "这种分歧并不新鲜，但这次的讨论出现了一个新变化：越来越多的读者开始把小说里具体的段落摘出来，逐条对照演员的过往片段，讨论这个角色到底难在哪里。",
      "有编剧在评论区写下长文，认为改编最大的难点并不是选角，而是原著中大量心理描写如何在影像中转译。这条回复获得了超过四千个赞，也被大量引用到后续讨论里。",
      "目前该剧尚未开机，制作方表示会认真听取观众意见。投票结果显示，超过一半的参与者选择了等预告片出来再评价。",
    ],
    pros: [
      "演员与角色的贴合度需要看整体表演，单凭外形照片下定论并不公平。",
      "改编本就需要重新创作，完全照搬原著反而容易让剧集失去节奏。",
      "制作方愿意公开听取意见，这本身就是行业进步的表现。",
    ],
    cons: [
      "原著角色的核心气质是明确的，选角偏离太远，改编从第一步就走偏了。",
      "书粉的坚持不是挑刺，而是对作品本身最基本的尊重。",
      "比起演员长相，更值得担心的是剧本把角色最精彩的部分删掉了。",
    ],
    attitude: { support: 38, neutral: 33, oppose: 29 },
    comments: [
      {
        id: "t3c1",
        nickname: "书页折角处",
        avatarClass: "bg-accent-100 text-accent-900",
        badge: "神评",
        content:
          "每次都这样：官宣的时候吵外形，开机的时候吵戏份，播出的时候吵结局。到最后真正被记住的，还是演得好不好。",
        likes: 3980,
        replies: 205,
        time: "1 天前",
      },
      {
        id: "t3c2",
        nickname: "演技观察员",
        avatarClass: "bg-secondary-100 text-secondary-900",
        badge: "高能",
        content: "我把这位演员近三年的作品剪了个二十分钟混剪，看完再判断比对着海报吵架有说服力多了。",
        likes: 3120,
        replies: 176,
        time: "1 天前",
      },
      {
        id: "t3c3",
        nickname: "只看剧不看书",
        avatarClass: "bg-primary-100 text-primary-800",
        badge: "热评",
        content: "作为没看过原著的观众，我只想知道故事讲得好不好。如果剧好看，我大概率会回头去补小说。",
        likes: 2240,
        replies: 130,
        time: "1 天前",
      },
      {
        id: "t3c4",
        nickname: "安静的读者",
        avatarClass: "bg-background-200 text-foreground-800",
        badge: "",
        content: "中立。选角是制作方的活儿，看不看是我的选择。与其在评论区吵，不如等成片。",
        likes: 1470,
        replies: 58,
        time: "2 天前",
      },
    ],
    poll: {
      question: "小说改编剧的选角，你更看重哪一点？",
      options: [
        { label: "外形气质与原著贴合", votes: 9240 },
        { label: "演员的表演功底", votes: 11360 },
        { label: "等预告片出来再评价", votes: 8890 },
      ],
      totalVotes: 29490,
      closesAt: "9 月 14 日 18:00",
    },
  },
  {
    id: "t4",
    title: "头部直播间退货率曝光，低价套路再度引发争议",
    category: "网络热点",
    categorySlug: "online",
    summary:
      "一份第三方数据报告显示，部分直播间的退货率明显高于行业均值。围绕低价是不是真便宜的讨论迅速升温，评论区高能回复与投票结果同步更新。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20poster%20style%20with%20warm%20cream%20paper%20background%20and%20soft%20studio%20lighting%2C%20stylized%20abstract%20composition%20representing%20cardboard%20shipping%20boxes%20and%20a%20microphone%20on%20a%20live%20streaming%20desk%2C%20muted%20crimson%20and%20amber%20accents%2C%20gentle%20grain%20texture%2C%20high%20detail%2C%20centered%20subject%2C%20no%20text&width=800&height=600&seq=bl-t4-cover&orientation=landscape",
    heat: 91250,
    commentCount: 3108,
    followers: 16720,
    author: "看点编辑组",
    date: "2026-09-08",
    tags: ["直播带货", "消费争议", "退货率"],
    readTime: "6 分钟阅读",
    content: [
      "报告的统计口径并不复杂：把同一商品在不同渠道的退货申请率做了横向对比，结果显示头部直播间的平均值高出平台均值约一倍。",
      "很快就有从业者在评论区解释，直播间退货率高有结构性原因，冲动下单的比例天然更高，加上仅退款流程便利，退货成本被大幅降低。",
      "但消费者的关注点显然不在这里。多条高赞评论把焦点放在了先涨后降的定价方式上，认为这才是退货多的根本原因。",
      "平台方面回应称将持续优化价格监测机制。本轮投票中，关于会不会因为主播推荐而下单的问题吸引了近四万人参与，结果相当微妙。",
    ],
    pros: [
      "直播间退货率高与消费习惯有关，不能简单等同于商品有问题。",
      "平台提供了七天无理由与仅退款，退货渠道顺畅本身就是消费者权益的体现。",
      "低价确实存在，只是需要消费者自己花时间比对，这是正常的市场行为。",
    ],
    cons: [
      "先提价再打折的套路，消耗的是消费者对整条直播链路的信任。",
      "主播在推荐时应当承担基本的选品责任，而不是只负责喊口号。",
      "退货率被当作好看的数据来包装，本身就是对真实体验的回避。",
    ],
    attitude: { support: 31, neutral: 21, oppose: 48 },
    comments: [
      {
        id: "t4c1",
        nickname: "比价小能手",
        avatarClass: "bg-primary-100 text-primary-800",
        badge: "神评",
        content:
          "我做过一个小实验：把同一件商品加入购物车放三天，直播间的限时价第四天涨了八块。这不叫低价，这叫耐心测试。",
        likes: 6120,
        replies: 402,
        time: "4 小时前",
      },
      {
        id: "t4c2",
        nickname: "只买过一次",
        avatarClass: "bg-secondary-100 text-secondary-900",
        badge: "高能",
        content: "退货率高不一定是货不好，也可能是因为买的时候太冲动。但主播把冲动当卖点天天喊，那就没什么好洗的了。",
        likes: 4530,
        replies: 261,
        time: "6 小时前",
      },
      {
        id: "t4c3",
        nickname: "物流站小哥",
        avatarClass: "bg-accent-100 text-accent-900",
        badge: "热评",
        content: "我们站点最忙的两天，就是大促之后第三天。退回来的箱子堆到门口，很多连胶带都没拆干净。",
        likes: 3280,
        replies: 149,
        time: "8 小时前",
      },
      {
        id: "t4c4",
        nickname: "理性消费者",
        avatarClass: "bg-background-200 text-foreground-800",
        badge: "",
        content: "我选支持，但理由和主播无关。平台规则让退货变容易，我买东西的心态确实放松了很多。",
        likes: 1690,
        replies: 71,
        time: "10 小时前",
      },
    ],
    poll: {
      question: "你会因为主播推荐而直接下单吗？",
      options: [
        { label: "会，价格合适就买", votes: 9840 },
        { label: "先加购物车观察几天", votes: 15320 },
        { label: "基本不在直播间买", votes: 12680 },
      ],
      totalVotes: 37840,
      closesAt: "9 月 12 日 24:00",
    },
  },
  {
    id: "t5",
    title: "短视频摆拍摆上热搜，平台治理规则被追问",
    category: "网络热点",
    categorySlug: "online",
    summary:
      "一段播放量破千万的短视频被网友指出是刻意摆拍，当事人随后承认情节经过了设计。评论区围绕内容创作自由与平台审核责任展开激烈交锋。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20poster%20style%20with%20warm%20cream%20paper%20background%20and%20soft%20studio%20lighting%2C%20stylized%20abstract%20composition%20representing%20a%20smartphone%20on%20a%20tripod%20with%20a%20ring%20light%20in%20a%20staged%20room%20corner%2C%20muted%20crimson%20and%20amber%20accents%2C%20gentle%20grain%20texture%2C%20high%20detail%2C%20centered%20subject%2C%20no%20text&width=800&height=600&seq=bl-t5-cover&orientation=landscape",
    heat: 68470,
    commentCount: 2190,
    followers: 11240,
    author: "看点编辑组",
    date: "2026-09-05",
    tags: ["短视频", "内容治理", "神评论"],
    readTime: "4 分钟阅读",
    content: [
      "视频里那位偶然路过的好心人，在网友比对多个账号发布的内容后被发现是固定出镜的演员。当事人随后在直播中承认，整个情节有剧本设计。",
      "这条消息引出的讨论很快超出了单个视频本身。评论区最集中的问题变成了：摆拍内容的边界在哪里，平台的标注机制为什么迟迟没有落地。",
      "有创作者在评论区表达了复杂的态度，适度设计情节是内容行业的常态，但把设计包装成真实记录去博取同情，性质就完全不同了。",
      "平台方在事件发酵一天后更新了创作规范，要求情节化内容进行明确标注。相关投票显示，绝大多数参与者支持强制标注。",
    ],
    pros: [
      "情节化创作是内容行业的一部分，观众本身也清楚短视频并不等于新闻。",
      "平台已经更新了标注规范，说明治理机制在动态调整。",
      "与其追问单个创作者，不如把讨论放在规则建设上更有价值。",
    ],
    cons: [
      "把摆拍说成真实记录，消耗的是观众对整个内容生态的信任。",
      "标注机制不该等到上了热搜才补，平台的技术能力完全支持提前落地。",
      "靠消费善意换来的流量，最终会反噬真正需要帮助的人。",
    ],
    attitude: { support: 24, neutral: 19, oppose: 57 },
    comments: [
      {
        id: "t5c1",
        nickname: "帧数担当",
        avatarClass: "bg-secondary-100 text-secondary-900",
        badge: "高能",
        content:
          "同一个路人，三个月出现在六个账号的视频里，连外套都是那件。这不是摆拍，这是连续剧。评论区侦探已经把出场时间表做出来了。",
        likes: 5560,
        replies: 371,
        time: "5 小时前",
      },
      {
        id: "t5c2",
        nickname: "不看热搜的一天",
        avatarClass: "bg-accent-100 text-accent-900",
        badge: "热评",
        content: "支持标注，但不支持一刀切。剧情短片、公益广告本来就有剧本，关键是别把观众当傻子。",
        likes: 3310,
        replies: 187,
        time: "7 小时前",
      },
      {
        id: "t5c3",
        nickname: "沉默的大多数",
        avatarClass: "bg-primary-100 text-primary-800",
        badge: "",
        content: "投票我选不能接受。不是针对这个视频，是不想以后每次看到求助都要先怀疑三秒。",
        likes: 2480,
        replies: 96,
        time: "9 小时前",
      },
      {
        id: "t5c4",
        nickname: "创作实习生",
        avatarClass: "bg-background-200 text-foreground-800",
        badge: "",
        content: "做内容的人都懂，完全真实的故事很难有节奏。但设计两个字写在片头，观众反而更愿意看完。",
        likes: 1620,
        replies: 73,
        time: "1 天前",
      },
    ],
    poll: {
      question: "情节化短视频是否应该强制标注有剧本？",
      options: [
        { label: "应该强制标注", votes: 21460 },
        { label: "看内容类型再定", votes: 5860 },
        { label: "没必要，观众能分辨", votes: 3140 },
      ],
      totalVotes: 30460,
      closesAt: "9 月 13 日 22:00",
    },
  },
  {
    id: "t6",
    title: "加班文化再上热搜：自愿加班到底算不算自愿",
    category: "社会民生",
    categorySlug: "society",
    summary:
      "一则关于部门自愿加班打卡的帖子引发广泛共鸣，评论区迅速聚集了大量职场经历分享。围绕加班补偿与制度设计的投票，参与人数持续攀升。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20poster%20style%20with%20warm%20cream%20paper%20background%20and%20soft%20studio%20lighting%2C%20stylized%20abstract%20composition%20representing%20an%20empty%20office%20desk%20at%20night%20with%20a%20single%20lamp%20and%20a%20wall%20clock%2C%20muted%20crimson%20and%20amber%20accents%2C%20gentle%20grain%20texture%2C%20high%20detail%2C%20centered%20subject%2C%20no%20text&width=800&height=600&seq=bl-t6-cover&orientation=landscape",
    heat: 74530,
    commentCount: 4020,
    followers: 19860,
    author: "看点编辑组",
    date: "2026-09-04",
    tags: ["职场话题", "评论区高能", "制度讨论"],
    readTime: "7 分钟阅读",
    content: [
      "帖子的内容并不复杂，发帖人称所在部门不接受加班申请，但每晚都会统计在岗时长，时长靠前的同事会在例会上被点名表扬。",
      "这类帖子之所以能引发大规模共鸣，是因为评论区里几乎每个人都找到了自己的影子。有人晒出连续三个月的打卡记录，有人分享了自己拒绝加班后被调岗的经历。",
      "在众多情绪化的回复中，几条偏理性的长评获得了更高的赞数。它们不约而同地提到了同一个问题：真正需要被讨论的不是要不要加班，而是加班之后有没有对应的补偿与选择权。",
      "劳动法相关从业者在评论区补充说明，认定加班的关键在于用人单位是否进行了实质性的工作安排，而自愿这两个字并不能自动免责。",
    ],
    pros: [
      "有些行业的项目周期确实紧张，阶段性加班在合理补偿下可以接受。",
      "职场选择是双向的，觉得不合适可以换环境，市场会逐步调节。",
      "企业也在改进，越来越多的公司开始用调休替代无偿加班。",
    ],
    cons: [
      "当加班时长被点名表扬，自愿就变成了没有写在纸上的强制。",
      "把统计在岗时间当成管理手段，本质上是用氛围替代制度。",
      "补偿不该靠员工自己去争取，而应该是管理的基本配置。",
    ],
    attitude: { support: 26, neutral: 18, oppose: 56 },
    comments: [
      {
        id: "t6c1",
        nickname: "工位上的植物",
        avatarClass: "bg-primary-100 text-primary-800",
        badge: "神评",
        content:
          "自愿两个字真好用。自愿加班、自愿放弃年假、自愿接受调岗。哪天要是能自愿涨薪，我一定第一个举手。",
        likes: 7240,
        replies: 512,
        time: "6 小时前",
      },
      {
        id: "t6c2",
        nickname: "十年老职员",
        avatarClass: "bg-secondary-100 text-secondary-900",
        badge: "高能",
        content:
          "我待过三家公司，真正让人愿意留下的从来不是免费夜宵，是加班之后第二天能名正言顺地晚到两小时。制度比情怀管用。",
        likes: 4890,
        replies: 264,
        time: "8 小时前",
      },
      {
        id: "t6c3",
        nickname: "刚入职的小陈",
        avatarClass: "bg-accent-100 text-accent-900",
        badge: "热评",
        content: "最难受的不是加班，是到了点不敢走。明明活干完了，还要在工位上再坐四十分钟，这种感觉比加班本身还累。",
        likes: 3920,
        replies: 208,
        time: "10 小时前",
      },
      {
        id: "t6c4",
        nickname: "理性讨论者",
        avatarClass: "bg-background-200 text-foreground-800",
        badge: "",
        content: "中立。项目冲刺期偶尔加班我能理解，但把统计时长当考核项就是另一回事了。这两者不该混为一谈。",
        likes: 2110,
        replies: 88,
        time: "1 天前",
      },
    ],
    poll: {
      question: "你所在的环境，加班有对应的补偿吗？",
      options: [
        { label: "有，调休或加班费", votes: 7910 },
        { label: "部分情况有", votes: 10430 },
        { label: "基本没有", votes: 18620 },
      ],
      totalVotes: 36960,
      closesAt: "9 月 15 日 20:00",
    },
  },
  {
    id: "t7",
    title: "抽卡概率公示后玩家仍不买账，保底机制该不该改",
    category: "游戏电竞",
    categorySlug: "game",
    summary:
      "某手游更新后公示了完整概率表，但玩家在实际体验中的感受与公示数据相差较大。围绕保底机制与概率透明度的讨论，成了玩家社区本周最大的争议点。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20poster%20style%20with%20warm%20cream%20paper%20background%20and%20soft%20studio%20lighting%2C%20stylized%20abstract%20composition%20representing%20glowing%20capsule%20toys%20and%20playing%20cards%20floating%20above%20a%20retro%20console%2C%20muted%20crimson%20and%20amber%20accents%2C%20gentle%20grain%20texture%2C%20high%20detail%2C%20centered%20subject%2C%20no%20text&width=800&height=600&seq=bl-t7-cover&orientation=landscape",
    heat: 52380,
    commentCount: 1960,
    followers: 9840,
    author: "看点编辑组",
    date: "2026-09-03",
    tags: ["抽卡概率", "玩家投票", "保底机制"],
    readTime: "5 分钟阅读",
    content: [
      "更新公告里，官方第一次把各个稀有度的出货概率完整列出，并在末尾附上了抽样数量说明。这份诚意按理说应该平息争议，但玩家社区的反应却相当微妙。",
      "核心矛盾在于个体体验与统计概率之间的落差。多名玩家在评论区贴出了自制的抽取记录表，样本量从几百次到上千次不等，结果分布与公示值存在肉眼可见的出入。",
      "也有玩家从另一个角度提出了建议，与其纠结概率数字，不如把保底机制做成积累型，让每一次未命中都能明确地推进下一次的进度。",
      "官方在次日回应称会优化抽取记录的展示方式。相关投票中，关于是否支持引入可积累通用保底的问题获得了压倒性的支持率。",
    ],
    pros: [
      "概率已经公示，说明官方愿意接受监督，比过去的不透明是明显进步。",
      "个体样本量太小，几百次抽取的波动属于正常统计现象。",
      "游戏需要收入支撑长期更新，抽卡机制是行业通行做法。",
    ],
    cons: [
      "公示了数字却不解释抽样方式，玩家自然会怀疑统计口径。",
      "保底机制的设计应该让玩家感受到确定性的积累，而不是全靠运气。",
      "概率透明只是第一步，真正的诚意是把抽取记录做得清晰可查。",
    ],
    attitude: { support: 29, neutral: 25, oppose: 46 },
    comments: [
      {
        id: "t7c1",
        nickname: "记录本玩家",
        avatarClass: "bg-secondary-100 text-secondary-900",
        badge: "高能",
        content:
          "我攒了 1200 次抽取记录，做成了折线图。公示说 2%，我这边是 1.3%。样本量确实不够大，但我至少把过程公开了，欢迎来对。",
        likes: 4120,
        replies: 296,
        time: "5 小时前",
      },
      {
        id: "t7c2",
        nickname: "佛系抽卡",
        avatarClass: "bg-accent-100 text-accent-900",
        badge: "神评",
        content: "公示概率的时候我信了，然后我连续歪了四次。现在我信的是保底，因为保底至少还讲道理。",
        likes: 3580,
        replies: 174,
        time: "7 小时前",
      },
      {
        id: "t7c3",
        nickname: "数据党上线",
        avatarClass: "bg-primary-100 text-primary-800",
        badge: "热评",
        content: "建议官方直接把每个账号的抽取历史做成一键导出，这样谁还敢质疑。技术难度真的不高。",
        likes: 2740,
        replies: 121,
        time: "9 小时前",
      },
      {
        id: "t7c4",
        nickname: "休闲玩家",
        avatarClass: "bg-background-200 text-foreground-800",
        badge: "",
        content: "中立。抽卡本来就是愿赌服输，我只希望保底进度条能写得再清楚一点，别让我自己去数。",
        likes: 1480,
        replies: 62,
        time: "1 天前",
      },
    ],
    poll: {
      question: "你支持引入可积累的通用保底机制吗？",
      options: [
        { label: "支持，进度应该可积累", votes: 16380 },
        { label: "保持现状即可", votes: 3020 },
        { label: "无所谓，看游戏好玩程度", votes: 4160 },
      ],
      totalVotes: 23560,
      closesAt: "9 月 14 日 22:00",
    },
  },
  {
    id: "t8",
    title: "演唱会退票规则调整，观众分成两派吵翻评论区",
    category: "生活消费",
    categorySlug: "life",
    summary:
      "多家演出主办方先后更新了退票政策，允许在特定时间内办理原价退票，但手续费与时间窗口的设置依然引发争议。评论区与投票结果同步呈现两派观点。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20poster%20style%20with%20warm%20cream%20paper%20background%20and%20soft%20studio%20lighting%2C%20stylized%20abstract%20composition%20representing%20concert%20stage%20lights%20and%20paper%20ticket%20stubs%20on%20a%20warm%20backdrop%2C%20muted%20crimson%20and%20amber%20accents%2C%20gentle%20grain%20texture%2C%20high%20detail%2C%20centered%20subject%2C%20no%20text&width=800&height=600&seq=bl-t8-cover&orientation=landscape",
    heat: 61920,
    commentCount: 2680,
    followers: 13260,
    author: "看点编辑组",
    date: "2026-09-02",
    tags: ["退票规则", "消费体验", "舆论分布"],
    readTime: "5 分钟阅读",
    content: [
      "新规则的核心变化是明确了退票时间窗口：开票后七天内可申请原价退票，演出前十五天内退票收取一定手续费，临近演出则不再受理。",
      "支持者认为这已经是对消费者相当友好的调整，毕竟此前大量演出采取的是售出概不退换的方式。反对的声音则集中在手续费比例和不可抗力的认定标准上。",
      "有票务从业者在评论区解释，演出票的退换涉及场地、制作等提前投入，完全无门槛退票在实际操作中很难落地，分档收费是行业内相对平衡的做法。",
      "投票数据显示，两派观点差距不大，中间选项占比接近三分之一，说明大多数观众的态度仍然是再看实施细则。",
    ],
    pros: [
      "七天无理由原价退票已经覆盖了大部分冲动购票的情况，是明显的进步。",
      "演出涉及大量前置成本，分档收取手续费符合实际经营逻辑。",
      "规则透明比口头承诺重要，把时间窗口写清楚本身就是进步。",
    ],
    cons: [
      "临近演出的手续费比例仍然偏高，遇到突发情况观众承担的成本太重。",
      "什么叫不可抗力应该给出明确列举，而不是由主办方单方面解释。",
      "退票通道的入口藏得很深，规则写得再好也需要实际能用。",
    ],
    attitude: { support: 37, neutral: 30, oppose: 33 },
    comments: [
      {
        id: "t8c1",
        nickname: "抢票三年选手",
        avatarClass: "bg-primary-100 text-primary-800",
        badge: "神评",
        content:
          "以前的规则是售出不退，现在是可退但收费。进步是有的，只是这个进步的速度，跟我抢票的手速比起来还是慢了太多。",
        likes: 3860,
        replies: 188,
        time: "6 小时前",
      },
      {
        id: "t8c2",
        nickname: "看演出不请假",
        avatarClass: "bg-accent-100 text-accent-900",
        badge: "高能",
        content:
          "真正的痛点是提前一个月买的票，结果档期突然撞了。如果手续费能按比例递减，而不是一刀切，接受度会高很多。",
        likes: 3120,
        replies: 156,
        time: "8 小时前",
      },
      {
        id: "t8c3",
        nickname: "票务从业者",
        avatarClass: "bg-secondary-100 text-secondary-900",
        badge: "热评",
        content: "说句职业相关的：场地和制作费用在开票前就付了。完全免费退票，最后的结果只会是票价整体上涨。",
        likes: 2460,
        replies: 209,
        time: "10 小时前",
      },
      {
        id: "t8c4",
        nickname: "普通的观众",
        avatarClass: "bg-background-200 text-foreground-800",
        badge: "",
        content: "中立。我更在意退票按钮放的位置，找了半天才找到入口，这种体验比手续费更让人上火。",
        likes: 1720,
        replies: 74,
        time: "1 天前",
      },
    ],
    poll: {
      question: "演出票分档收取退票手续费，你认可吗？",
      options: [
        { label: "认可，规则透明就好", votes: 11240 },
        { label: "手续费应该更低", votes: 9860 },
        { label: "看具体档位再判断", votes: 8390 },
      ],
      totalVotes: 29490,
      closesAt: "9 月 16 日 20:00",
    },
  },
];

export const hotKeywords = [
  "剧组后勤",
  "综艺剪辑",
  "选角争议",
  "直播退货率",
  "短视频摆拍",
  "加班补偿",
  "抽卡保底",
  "演唱会退票",
  "评论区高能",
  "网友神评论",
];